module.exports = __webpack_public_path__ + "img/GI0003.00c5ac3.webp";